export const normalizeGender = (gender) => {
    const g = gender.toLowerCase();
    if (g.includes('female'))
        return 'female';
    if (g.includes('male') || g === 'm')
        return 'male';
    if (g === 'f')
        return 'female';
    return g;
};
export function normalizeGenderCode(gender) {
    const upper = gender.toUpperCase();
    const isMale = (upper.includes('MALE') && !upper.includes('FEMALE')) ||
        (upper.includes('M') && !upper.includes('F'));
    return isMale ? 'M' : 'F';
}
